import React from 'react';
import cx from 'classnames';

import IconButton from '../IconButton';
import CloseS2 from '../Icons/CloseS2';

import styles from './Label.module.scss';

export interface Props {
  children?: React.ReactNode;
  className?: Parameters<typeof cx>[0];
  onClick?: () => void;
  accessibilityLabel?: string;
  noIcon?: boolean;
}

export const Label: React.FC<Props> = ({
  accessibilityLabel,
  children,
  className,
  noIcon,
  onClick,
}) => (
  <span className={cx(styles.label, noIcon && styles.noIcon, className)}>
    {children}{' '}
    {!noIcon && onClick != null && (
      <IconButton
        accessibilityLabel={accessibilityLabel || 'Remove'}
        icon={<CloseS2 />}
        onClick={onClick}
        className={styles.iconBtn}
      />
    )}
  </span>
);

Label.displayName = 'Label';
export default Label;
export { styles };
